module.exports = __webpack_public_path__ + "static/images/b5455bbf8a18e341cf876f33716d32a3.webp";